<template>
  <div class="progress-bar">
    <div class="indicator" :style="{'width': fill + '%'}"></div>
  </div>
</template>
<script>
  export default {
    props: ['fill'],
  }
</script>
<style lang="scss">
  .progress-bar {
    height: 4px;
    flex-grow: 1;
    background: #D5D5D5;
    border-radius: 4px;

    .indicator {
      background: #FF7800;
      border-radius: 4px;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/progress-bar.vue